import FallcoConsole from '../../fallco_console';
import FallcoNotify  from '../../notify';
import Utilities     from '../../utilities';

class AjaxDownloader {
  
  constructor(props) {
    this.eventDownloadComplete = null;
    this.clickedElement = null;
  }
  
  /**
   *
   * @param {String} url
   * @param {String} [file_name]
   * @private
   */
  _download_for_ie9 (url, file_name) {
    let link  = document.createElement('a');
    link.href = url;
    link.setAttribute('download', file_name);
    
    document.body.appendChild(link);
    
    link.addEventListener('click', function (ev) {
      // console.log(ev);
    });
    
    link.click();
    
    document.body.removeChild(link);
    if(this.eventDownloadComplete === true) {
      document.dispatchEvent(new CustomEvent('download_completo',{detail:{file_name:file_name, targetClicked:(this.clickedElement) ? this.clickedElement : null }}));
    }
  }
  
  /**
   *
   * @param response
   * @param [file_name]
   * @private
   */
  _download_for_ie10 (response, file_name) {
    let fileData   = [response];
    let blobObject = new Blob(fileData);
    window.navigator.msSaveOrOpenBlob(blobObject, file_name);
    if(this.eventDownloadComplete === true) {
      document.dispatchEvent(new CustomEvent('download_completo',{detail:{file_name:file_name, targetClicked:(this.clickedElement) ? this.clickedElement : null }}));
    }
  }
  
  /**
   *
   * @param response
   * @param [file_name]
   * @private
   */
  _download_for_other (response, file_name) {
    let url    = URL.createObjectURL(response);
    let link   = document.createElement('a');
    let origin = window.location.origin;
    
    if (url.indexOf(origin) === -1) {
      url = 'blob:' + origin + '/' + url.split(':')[1];
    }
    
    link.setAttribute('href', url);
    link.setAttribute('download', (!(file_name instanceof Array) ? file_name : file_name[0]));
    link.setAttribute('target', '_blank');
    
    document.body.appendChild(link);
    link.click();
    
    document.body.removeChild(link);
    if(this.eventDownloadComplete === true) {
      document.dispatchEvent(new CustomEvent('download_completo',{detail:{file_name:file_name, targetClicked:(this.clickedElement) ? this.clickedElement : null }}));
    }
  }
  
  _startXHRCall (url) {
    let xhr = new XMLHttpRequest();
    
    xhr.open('GET', url);
    
    xhr.responseType = 'blob';
    
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.setRequestHeader('Access-Control-Expose-Headers', 'Content-Disposition');
  
    //Download progress
    xhr.addEventListener('progress', evt => this._onProgress(evt), false);
  
    xhr.onload = (...attrs) => this._onXHRLoad(...attrs, xhr);
    xhr.send();
  }
  
  _onProgress(evt){
    if (evt.lengthComputable) {
      const percent_complete = (evt.loaded / evt.total) * 100;
    
      evt.percent_complete = percent_complete;
    
      $.helper.loading_frame.self.set_sub('... download in corso (' + percent_complete.toFixed(0) + '%) ...', true);
    }
  }
  
  _onXHRLoad(progress, xhr){
    switch (xhr.status) {
    case 200:
      const respHeader = xhr.getResponseHeader('content-disposition');
  
      if (!respHeader) {
    
        try {
          xhr.response.text().then(resp => {
            this._onDownloadError(resp);
          });
        } catch (e) {
          this._onDownloadError(e);
        }
    
        return;
      }
  
      let file_name = xhr.getResponseHeader('content-disposition').match(/filename.*/);
  
      file_name = file_name[0].replace(/(["=])|(filename)/g, '');
  
      if (window.navigator.msSaveOrOpenBlob) {
        this._download_for_ie10(xhr.response, file_name);
      } else if (window.URL) {
        this._download_for_other(xhr.response, file_name);
      }

      $.helper.loading_frame.hide();

      break;
      case 404:
        FallcoNotify.error('Il file richiesto non &egrave; stato trovato.');
        $.helper.loading_frame.hide();
        break;
      case 400:
        try {
          xhr.response.text().then(resp => {
            this._onDownloadError(resp);
          });
        } catch (e) {
          this._onDownloadError(e);
        }
        break;
      default:
        FallcoNotify.error(xhr.statusText);
        $.helper.loading_frame.hide();
        break;
    }
  
  }
  
  _onDownloadError(resp) {
    const errorMessage = 'A causa di un errore il download &egrave; fallito.<br><br><strong>Errore:</strong><br>';
    let jsonResp       = null;
    
    if (typeof resp === 'string') {
      jsonResp = Utilities.tryJsonParse(resp);
    } else if (resp.message) {
      jsonResp = resp;
    }
    
    // Se non è un JSON ritorna il testo passato.
    if (!jsonResp) {
      FallcoNotify.error(errorMessage + resp);
    } else {
      FallcoNotify.error(errorMessage + jsonResp.message);
    }
    
    $.helper.loading_frame.hide();
  }
  
  downloadFile(url, showMessage = true, eventDownloadComplete = false, clickedElement = false) {
    FallcoConsole.log('Download file url', url);
    if(eventDownloadComplete != false){
      this.eventDownloadComplete = eventDownloadComplete;
    }

    if(clickedElement != false){
      this.clickedElement = event.target;
    }
    
    if ($.helper && $.helper.loading_frame && $.helper.loading_frame.self.counter <= 0) {
      $.helper.loading_frame.show();
      
      if (showMessage) {
        $.helper.loading_frame.self.set_sub('... download in corso ...', true);
      }
    }
    
    if (!window.Blob) {
      this._download_for_ie9(url);
      
      return;
    }
    
    this._startXHRCall(url);
    
  }
}

export default new AjaxDownloader();
